module.exports = __webpack_public_path__ + "59d0f7e0911da83d6f11c47ec9988f29.ttf";